export default function validateEmailFormat(email: string): boolean {
  return email.includes('@')
}
